import axios from "../../helpers/httpClient";

export default {
    getGridLayout: async ({ commit, state, dispatch },idMoment) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const grid = await axios.get(`/information/private/management/getGridLayout`, {
                customData: {idMoment}}, {
                headers: { 'Content-Type': 'application/json' }
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (grid.status === 200) {
                commit('SET_GRID', grid.data.grid);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getHojasLayout: async ({ commit, state, dispatch },idMoment) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const hojas = await axios.get(`/information/private/management/getHojasLayout`, {
                customData: {idMoment}}, {
                headers: { 'Content-Type': 'application/json' }
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (hojas.status === 200) {
                commit('SET_HOJAS', hojas.data.hojas);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addGridLayout: async ({ commit, state, dispatch }, data) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateGrid = state.grid;

            const gridAdded = await axios.post("/information/private/management/addGridLayout", {
                data,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (gridAdded.status === 200) {
                stateGrid.push(gridAdded.data.data)

                commit('SET_GRID', stateGrid);

                dispatch('activeMessageCorrect', gridAdded.data.message)
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editGridLayout: async ({ commit, state, dispatch }, data) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateGrid = state.grid;

            const gridEdited = await axios.post("/information/private/management/editGridLayout", {
                data,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (gridEdited.status === 200) {
                stateGrid.push(gridEdited.data.data)

                commit('SET_GRID', stateGrid);

                dispatch('activeMessageCorrect', gridEdited.data.message)
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
}